"use client";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";

const LinkComponent = ({ label }: { label: string }) => {
  return (
    <Button
      variant={"link"}
      w="fit-content"
      textDecor={"underline"}
      textDecorationColor={"#F9AF18"}
      textDecorationThickness={"1px"}
      textUnderlineOffset={"4px"}
      onClick={() => scrollToElement("contact-us", 120)}
    >
      {label}
    </Button>
  );
};

export default LinkComponent;
